// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: gray;
}

.silver {
  color: #C3CDE6;
}

.gold {
  color: gold;
}

.brown {
  color: brown;
}

.fbox {
  flex: 1;
  display: flex;
}

.vflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
}

.hflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.shadow-gray {
  border: 1px solid lightgray;
  box-shadow: 2px 2px 5px 1px lightgray;
}

.space-between {
  /* previous syntax */
  -ms-box-pack: justify;
  box-pack: justify;
  /* current syntax */
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}

.flex-left {
  justify-self: flex-start;
  margin-right: auto;
}

.flex-right {
  justify-self: flex-end;
  margin-left: auto;
}

.right-margin-20 {
  margin-right: 20px;
}

.left-margin-20 {
  margin-left: 20px;
}

.bottom-margin-20 {
  margin-bottom: 20px;
}

.bottom-margin-30 {
  margin-bottom: 30px;
}

.bottom-margin-40 {
  margin-bottom: 40px;
}

.top-margin-20 {
  margin-top: 20px;
}

.top-margin-40 {
  margin-top: 40px;
}

.margin-auto {
  margin: auto;
}

.h-margin-auto {
  margin-right: auto;
  margin-left: auto;
}

.v-margin-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.flex-30 {
  flex: 0 0 30%;
}

.flex-90 {
  flex: 0 0 90%;
}

.padding-right-10 {
  padding-right: 10%;
}

.main {
  /* previous syntax */
  -ms-box-flex: 1;
  box-flex: 1;
  /* current syntax */
  -moz-flex: 1;
  flex: 1;
  height: 100%;
  width: 100%;
  margin: 0;
  overflow-y: auto;
}

.main-header-container {
  margin-bottom: 20px;
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}
.main-header-container .main-header {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
  flex-wrap: wrap;
}
.main-header-container .main-header .main-header-title {
  font-size: 1.25rem;
  flex-basis: 100%;
  font-weight: 500;
}
.main-header-container .main-header .main-header-icon {
  color: rgba(28, 129, 158, 0.8);
  font-size: 28px;
  margin-right: 10px;
  align-self: center;
  text-shadow: 2px 2px lightgray;
}

.main-aside-open {
  padding-right: 320px;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}

.sunken {
  box-shadow: 1px 3px 5px -1px rgba(0, 0, 0, 0.2) inset, 1px 6px 10px 0 rgba(0, 0, 0, 0.14) inset, 1px 1px 18px 0 rgba(0, 0, 0, 0.12) inset;
}

.gray {
  color: gray;
}

.silver {
  color: #C3CDE6;
}

.gold {
  color: gold;
}

.brown {
  color: brown;
}

.fbox {
  flex: 1;
  display: flex;
}

.vflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
}

.hflex {
  /* current syntax */
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -moz-flex-direction: row;
  flex-direction: row;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.shadow-gray {
  border: 1px solid lightgray;
  box-shadow: 2px 2px 5px 1px lightgray;
}

.space-between {
  /* previous syntax */
  -ms-box-pack: justify;
  box-pack: justify;
  /* current syntax */
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}

.flex-left {
  justify-self: flex-start;
  margin-right: auto;
}

.flex-right {
  justify-self: flex-end;
  margin-left: auto;
}

.right-margin-20 {
  margin-right: 20px;
}

.left-margin-20 {
  margin-left: 20px;
}

.bottom-margin-20 {
  margin-bottom: 20px;
}

.bottom-margin-30 {
  margin-bottom: 30px;
}

.bottom-margin-40 {
  margin-bottom: 40px;
}

.top-margin-20 {
  margin-top: 20px;
}

.top-margin-40 {
  margin-top: 40px;
}

.margin-auto {
  margin: auto;
}

.h-margin-auto {
  margin-right: auto;
  margin-left: auto;
}

.v-margin-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.flex-30 {
  flex: 0 0 30%;
}

.flex-90 {
  flex: 0 0 90%;
}

.padding-right-10 {
  padding-right: 10%;
}

.modal-dialog.modal-fullscreen-url-viewer-down {
  width: 90vw;
  max-width: none;
  height: 100%;
  margin: auto;
  padding-top: 30px;
}
.modal-dialog.modal-fullscreen-url-viewer-down .modal-body {
  padding: 1rem;
}

.suggestion-html-content > a {
  color: #067272;
  font-weight: 500;
  cursor: auto;
}

@media (min-width: 800px) {
  .modal-dialog {
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
}
.modal-body .h6, .modal-body .h6, .modal-body h5, .modal-body .h5, .modal-body h4, .modal-body .h4, .modal-body h3, .modal-body .h3, .modal-body h2, .modal-body .h2, .modal-body h1, .modal-body .h1 {
  margin-bottom: 1.25rem;
  color: #022B2A;
}

/* The styles above for the modal-body, footer, etc aren't being applied so I tried the ones below and they work */
.modal-body {
  height: 100%;
}

.light-style__logo-container img {
  width: 170px;
  display: flex;
  /* padding: 0px; */
  align-items: center;
  background: none;
  border: 0px;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
  margin: 20px;
}

.light-style__floating-form-container {
  width: 350px;
  margin: 20px auto;
  background-color: inherit;
  border-radius: 15px;
  padding: 4px;
}

.light-style__form-group {
  margin-top: 20px;
}
.light-style__form-group label {
  display: block;
  margin-bottom: 10px;
}
.light-style__form-group input {
  min-width: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  border: 1px solid #c4c7cf;
  border-radius: 6px;
  box-sizing: border-box;
  color: #191b23;
  font-size: inherit;
  text-overflow: ellipsis;
  font-family: inherit;
}

.light-style__form-divider {
  position: relative;
  margin-top: 14px;
  margin-bottom: 16px;
  text-align: center;
  border-top: 1px solid #d1d4db;
}
.light-style__form-divider .divider-inner {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
}
.light-style__form-divider .divider-inner .divider-text {
  background-color: #fff;
  padding: 0 25px;
  font-size: 14px;
}

.light-style__quiet-link {
  display: inline-block;
  font-family: inherit;
  color: #006dca;
  line-height: normal;
  position: relative;
  cursor: pointer;
  -webkit-text-decoration: none;
  text-decoration: none;
  border: 0;
  padding: 0;
  margin: 0;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  outline: 0;
  background: 0 0;
  transition: color 0.15s ease-in-out;
}

.light-style__button_form-submit {
  background-color: rgba(205, 227, 227, 0.8);
  width: 100%;
  border: 0;
  position: relative;
  margin-bottom: 12px;
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
}

.light-style__button_third-party-auth {
  background-color: #fff;
  width: 100%;
  border: 1px solid #c4c7cf;
  position: relative;
  margin-bottom: 12px;
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}
.light-style__button_third-party-auth img {
  margin-top: -4px;
}

.button_full-width {
  width: 100%;
}

.light-style__cancel-button {
  background-color: #fff;
  border: 1px solid #022B2A;
  color: #022B2A;
  padding: 10px 16px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
}

.light-style__confirm-button {
  background-color: #022B2A;
  border: 1px solid #022B2A;
  color: #fff;
  padding: 10px 16px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
}

main.light-style__page-container {
  padding: 20px 40px;
  max-width: 1080px;
}
main.light-style__page-container h5, main.light-style__page-container .h5 {
  font-size: 1.625rem;
}
main.light-style__page-container .page-header {
  margin: 0;
}
main.light-style__page-container section {
  margin-bottom: 30px;
}
main.light-style__page-container .section-discription {
  font-size: 1em;
  color: lightslategray;
  margin-bottom: 20px;
}

.light-style__modal-container > * {
  padding: 1rem 2rem;
}
.light-style__modal-container h5, .light-style__modal-container .h5 {
  font-size: 1.625rem;
}
.light-style__modal-container h6 {
  color: #022B2A;
  font-weight: bold;
}
.light-style__modal-container .modal-header {
  display: flex;
  flex-direction: column;
  align-items: normal;
  border-bottom: 1px solid #E5E5E5;
}
.light-style__modal-container .page-header {
  margin: 0;
}
.light-style__modal-container section {
  margin-bottom: 30px;
}
.light-style__modal-container .section-discription {
  font-size: 1em;
  color: lightslategray;
}

#login-container > h2 {
  margin-bottom: 35px;
  justify-content: center;
}
#login-container > h2 :first-child {
  display: flex;
  align-self: center;
}
#login-container > h2 :nth-child(2) {
  margin-bottom: -5px;
  display: flex;
}
#login-container > h2 .inline-logo {
  width: 200px;
  display: flex;
  align-items: center;
  border: 0px;
  border-radius: 3px;
  color: inherit;
  cursor: pointer;
  margin-left: 2px;
}

#reset-message-container {
  margin-top: 10px;
  margin-bottom: 25px;
  text-align: right;
}

#register-message-container {
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
#register-message-container :first-child {
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/scss/colors.scss","webpack://./src/app/views/login/login.component.scss","webpack://./src/scss/mixins.scss","webpack://./src/scss/main.scss","webpack://./src/scss/overrides.scss","webpack://./src/scss/light-style.scss"],"names":[],"mappings":"AAUA;EACI,WAAA;ACTJ;;ADWA;EACI,cAAA;ACRJ;;ADUA;EACI,WAAA;ACPJ;;ADSA;EACI,YAAA;ACNJ;;ACoFA;EACE,OAAA;EACA,aAAA;ADjFF;;ACoFA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,2BAAA;EAEK,sBAAA;ADlFV;;ACqFA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,wBAAA;EAEK,mBAAA;ADnFV;;ACsFA;EAEI,mBAAA;EACA,uBAAA;ADpFJ;;ACuFA;EACI,2BAAA;EACA,qCAAA;ADpFJ;;ACuFA;EACI,oBAAA;EAGI,qBAAA;EACI,iBAAA;EAER,mBAAA;EAEI,mCAAA;EACA,kCAAA;EACI,8BAAA;ADrFZ;;ACwFA;EACI,wBAAA;EACA,kBAAA;ADrFJ;;ACwFA;EACI,sBAAA;EACA,iBAAA;ADrFJ;;ACwFA;EACI,kBAAA;ADrFJ;;ACwFA;EACI,iBAAA;ADrFJ;;ACwFA;EACI,mBAAA;ADrFJ;;ACwFA;EACI,mBAAA;ADrFJ;;ACwFA;EACI,mBAAA;ADrFJ;;ACwFA;EACI,gBAAA;ADrFJ;;ACwFA;EACI,gBAAA;ADrFJ;;ACwFA;EACI,YAAA;ADrFJ;;ACuFA;EACI,kBAAA;EACA,iBAAA;ADpFJ;;ACsFA;EACI,gBAAA;EACA,mBAAA;ADnFJ;;ACsFA;EACI,aAAA;ADnFJ;;ACsFA;EACI,aAAA;ADnFJ;;ACsFA;EACI,kBAAA;ADnFJ;;AE9HA;EACI,oBAAA;EAGI,eAAA;EACI,WAAA;EAER,mBAAA;EAEI,YAAA;EAEI,OAAA;EAER,YAAA;EACA,WAAA;EACA,SAAA;EAGA,gBAAA;AF6HJ;;AE1HA;EAEI,mBAAA;EDRA,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGI,wBAAA;EAEI,mBAAA;ADoIZ;AEjII;EDZA,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGI,wBAAA;EAEI,mBAAA;ECKJ,eAAA;AF2IR;AE1IQ;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AF4IZ;AEzIQ;EACI,8BHrCG;EGsCH,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;AF2IZ;;AEtIA;EACI,oBAAA;AFyIJ;;AEtIA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AFyIJ;;AElIA;EACI,yIACI;AFoIR;;AD7LA;EACI,WAAA;ACgMJ;;AD9LA;EACI,cAAA;ACiMJ;;AD/LA;EACI,WAAA;ACkMJ;;ADhMA;EACI,YAAA;ACmMJ;;ACrHA;EACE,OAAA;EACA,aAAA;ADwHF;;ACrHA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,2BAAA;EAEK,sBAAA;ADuHV;;ACpHA;EACE,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EAGG,wBAAA;EAEK,mBAAA;ADsHV;;ACnHA;EAEI,mBAAA;EACA,uBAAA;ADqHJ;;AClHA;EACI,2BAAA;EACA,qCAAA;ADqHJ;;AClHA;EACI,oBAAA;EAGI,qBAAA;EACI,iBAAA;EAER,mBAAA;EAEI,mCAAA;EACA,kCAAA;EACI,8BAAA;ADoHZ;;ACjHA;EACI,wBAAA;EACA,kBAAA;ADoHJ;;ACjHA;EACI,sBAAA;EACA,iBAAA;ADoHJ;;ACjHA;EACI,kBAAA;ADoHJ;;ACjHA;EACI,iBAAA;ADoHJ;;ACjHA;EACI,mBAAA;ADoHJ;;ACjHA;EACI,mBAAA;ADoHJ;;ACjHA;EACI,mBAAA;ADoHJ;;ACjHA;EACI,gBAAA;ADoHJ;;ACjHA;EACI,gBAAA;ADoHJ;;ACjHA;EACI,YAAA;ADoHJ;;AClHA;EACI,kBAAA;EACA,iBAAA;ADqHJ;;ACnHA;EACI,gBAAA;EACA,mBAAA;ADsHJ;;ACnHA;EACI,aAAA;ADsHJ;;ACnHA;EACI,aAAA;ADsHJ;;ACnHA;EACI,kBAAA;ADsHJ;;AGhUA;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AHmUJ;AGjUI;EACE,aAAA;AHmUN;;AG1TA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;AH6TF;;AGpTA;EAEE;IACE,2BAAA;IAAA,sBAAA;EHsTF;AACF;AG/SE;EACE,sBAAA;EACA,cAAA;AHiTJ;;AG7OE,kHAAA;AACA;EACE,YAAA;AHgPJ;;AIzWA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AJ4WJ;;AIzWA;EACI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AJ4WJ;;AIzWA;EACI,gBAAA;AJ4WJ;AI1WI;EACI,cAAA;EACA,mBAAA;AJ4WR;AIzWI;EAKI,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;AJuWR;;AInWA;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AJsWJ;AIrWI;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;AJuWR;AItWQ;EACI,sBAAA;EACA,eAAA;EACA,eAAA;AJwWZ;;AIhWA;EACI,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,wCAAA;EACA,UAAA;EACA,eAAA;EACA,mCAAA;AJmWJ;;AI7VA;EACI,0CAAA;EACA,WAAA;EACA,SAAA;EAEA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AJ+VJ;;AI5VA;EACI,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AJ+VJ;AI7VI;EACI,gBAAA;AJ+VR;;AI3VA;EACI,WAAA;AJ8VJ;;AI3VA;EACI,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AJ8VJ;;AI3VA;EACI,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AJ8VJ;;AIxVA;EAEI,kBAAA;EACA,iBAAA;AJ0VJ;AIvVI;EACI,mBAAA;AJyVR;AItVI;EACI,SAAA;AJwVR;AIrVI;EACI,mBAAA;AJuVR;AIpVI;EACI,cAAA;EACA,qBAAA;EACA,mBAAA;AJsVR;;AIjVI;EACI,kBAAA;AJoVR;AIjVI;EACI,mBAAA;AJmVR;AIhVI;EACI,cAAA;EACA,iBAAA;AJkVR;AI/UI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gCAAA;AJiVR;AI9UI;EACI,SAAA;AJgVR;AI7UI;EACI,mBAAA;AJ+UR;AI5UI;EACI,cAAA;EACA,qBAAA;AJ8UR;;AA1hBA;EACI,mBAAA;EACA,uBAAA;AA6hBJ;AA3hBI;EACI,aAAA;EACA,kBAAA;AA6hBR;AA1hBI;EACI,mBAAA;EACA,aAAA;AA4hBR;AAzhBI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EAEA,gBAAA;AA0hBR;;AAthBA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;AAyhBJ;;AAthBA;EACI,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,uBAAA;AAwhBJ;AAthBI;EAEI,gBAAA;AAuhBR","sourcesContent":["$gray: gray !default;\n$silver: #C3CDE6 !default;\n$gold: gold !default;\n$brown: brown !default;\n$andrena-blue: rgba(28, 129, 158, 0.8);\n$black: black !default;\n$lightgray: lightgray !default;\n$darkgray: darkgray !default;\n$white: white !default;\n\n.gray {\n    color: gray;\n}\n.silver {\n    color:#C3CDE6;\n}\n.gold {\n    color: gold;\n}\n.brown {\n    color: brown;\n}\n  ","@import \"../../../scss/index.scss\";\n\n#login-container > h2 {\n    margin-bottom: 35px;\n    justify-content: center;\n\n    :first-child {\n        display: flex;\n        align-self: center;\n    }\n\n    :nth-child(2) {\n        margin-bottom: -5px;\n        display: flex;\n    }\n\n    .inline-logo {\n        width: 200px;\n        display: flex;\n        align-items: center;\n        border: 0px;\n        border-radius: 3px;\n        color: inherit;\n        cursor: pointer;\n        //margin: 20px;\n        margin-left: 2px;\n    }\n}\n\n#reset-message-container {\n    margin-top: 10px;\n    margin-bottom: 25px;\n    text-align: right;\n}\n\n#register-message-container {\n    margin-top: 10px;\n    margin-bottom: 20px;\n    //text-align: center;\n    display: flex;\n    justify-content: center;\n\n    :first-child\n    {\n        margin-left: 5px;\n    }\n}\n","@mixin fbox {\n    flex:1;\n    display: flex;\n}\n  \n@mixin vflex {\n    /* current syntax */\n    display: -webkit-flex;\n    display:    -moz-flex;\n    display:     -ms-flex;\n    display:         flex;\n\n    -webkit-flex-direction: column;\n        -moz-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n\n@mixin hflex {\n    /* current syntax */\n    display: -webkit-flex;\n    display:    -moz-flex;\n    display:     -ms-flex;\n    display:         flex;\n\n    -webkit-flex-direction: row;\n        -moz-flex-direction: row;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n\n@mixin overflow-hidden {\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n@mixin shadow-gray {\n    box-shadow: 2px 2px 0px 0px $lightgray,\n}\n\n@mixin center-margin {\n    margin-right: auto;\n    margin-left: auto;\n}\n\n@mixin shadow1 {\n    box-shadow: 2px 2px 0px 0px $lightgray,\n        0px 0px 6px 0px $lightgray;\n}\n\n@mixin border1 {\n    border: 1px solid $lightgray;\n}\n\n@mixin rounded-border1 {\n    border: 1px solid $lightgray;\n    border-radius: 8px;\n}\n\n@mixin space-between {\n    /* previous syntax */\n    -webkit-box-pack: justify;\n    -moz-box-pack: justify;\n    -ms-box-pack: justify;\n        box-pack: justify;\n\n    /* current syntax */\n    -webkit-justify-content: space-between;\n    -moz-justify-content: space-between;\n    -ms-justify-content: space-between;\n        justify-content: space-between;\n}\n\n@mixin flex-left {\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n@mixin flex-right {\n    justify-self: flex-end;\n    margin-left: auto;\n}\n\n@mixin sunken {\n    box-shadow: \n        1px 3px 5px -1px rgb(0 0 0 / 20%) inset, \n        1px 6px 10px 0 rgb(0 0 0 / 14%) inset, \n        1px 1px 18px 0 rgb(0 0 0 / 12%) inset;\n}\n\n@mixin hive-splash1 {\n    content: \"\";\n    background-image: url(\"/assets/bg1.jpg\");\n    opacity: 1;\n    background-repeat: no-repeat;\n    background-size: cover; \n}\n\n.fbox {\n  flex:1;\n  display: flex;\n}\n\n.vflex {\n  /* current syntax */\n  display: -webkit-flex;\n  display:    -moz-flex;\n  display:     -ms-flex;\n  display:         flex;\n\n  -webkit-flex-direction: column;\n     -moz-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.hflex {\n  /* current syntax */\n  display: -webkit-flex;\n  display:    -moz-flex;\n  display:     -ms-flex;\n  display:         flex;\n\n  -webkit-flex-direction: row;\n     -moz-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n\n.flex-center {\n    //display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.shadow-gray {\n    border: 1px solid $lightgray;      \n    box-shadow: 2px 2px 5px 1px $lightgray;\n}\n\n.space-between {\n    /* previous syntax */\n    -webkit-box-pack: justify;\n        -moz-box-pack: justify;\n        -ms-box-pack: justify;\n            box-pack: justify;\n\n    /* current syntax */\n    -webkit-justify-content: space-between;\n        -moz-justify-content: space-between;\n        -ms-justify-content: space-between;\n            justify-content: space-between;\n}\n\n.flex-left {\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n.flex-right {\n    justify-self: flex-end;\n    margin-left: auto;\n}\n\n.right-margin-20 {\n    margin-right: 20px;\n}\n\n.left-margin-20 {\n    margin-left: 20px;\n}\n\n.bottom-margin-20 {\n    margin-bottom: 20px;\n}\n\n.bottom-margin-30 {\n    margin-bottom: 30px;\n}\n\n.bottom-margin-40 {\n    margin-bottom: 40px;\n}\n\n.top-margin-20 {\n    margin-top: 20px;\n}\n\n.top-margin-40 {\n    margin-top: 40px;\n}\n\n.margin-auto {\n    margin:auto\n}\n.h-margin-auto {\n    margin-right: auto;\n    margin-left: auto;\n}\n.v-margin-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.flex-30 {\n    flex: 0 0 30%;\n}\n\n.flex-90 {\n    flex: 0 0 90%;\n}\n\n.padding-right-10 {\n    padding-right: 10%;\n}","@import './colors.scss';\n@import './mixins.scss';\n\n// Styles for main view container\n.main {\n    /* previous syntax */\n    -webkit-box-flex: 1;\n        -moz-box-flex: 1;\n        -ms-box-flex: 1;\n            box-flex: 1;\n\n    /* current syntax */\n    -webkit-flex: 1;\n        -moz-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    //padding: 10px;\n    //padding: 10px 6% 10px 6%;\n    overflow-y: auto;\n}\n\n.main-header-container {\n    //font-size: 20px;\n    margin-bottom: 20px;\n    // margin-top: 20px;\n    //font-family: 'Alice', serif;\n    @include hflex;\n    .main-header {\n        @include hflex;\n        flex-wrap: wrap;\n        .main-header-title {\n            font-size: 1.25rem;\n            flex-basis: 100%;\n            font-weight: 500;\n            //text-shadow: 2px 2px $lightgray;\n        }\n        .main-header-icon {\n            color: $andrena-blue;\n            font-size: 28px;\n            margin-right: 10px;\n            align-self: center;\n            text-shadow: 2px 2px $lightgray;\n        }\n    }\n}\n\n.main-aside-open {\n    padding-right: calc(320px + 0px);\n}\n\n.main-content {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    height: 100%;\n}\n\n.main-loading-container {\n    //Todo: add styling for loading \n}\n\n.sunken {\n    box-shadow: \n        1px 3px 5px -1px rgb(0 0 0 / 20%) inset, \n        1px 6px 10px 0 rgb(0 0 0 / 14%) inset, \n        1px 1px 18px 0 rgb(0 0 0 / 12%) inset;\n}\n","// button {\n//     background-color: inherit;\n// }\n\n// $table-cell-padding-y:        .5rem;\n// $table-cell-padding-x:        1.5rem;\n// $table-cell-padding-y-sm:     .25rem;\n// $table-cell-padding-x-sm:     .25rem;\n\n// modal overrides\n\n.modal-dialog.modal-fullscreen-url-viewer-down {\n    width: 90vw;\n    max-width: none;\n    height: 100%;\n    margin: auto;\n    padding-top: 30px;\n\n    .modal-body {\n      padding: 1rem;\n    }\n}\n\n.modal-dialog {\n  //max-width: 600px;\n  //margin: 8rem auto;\n}\n\n.suggestion-html-content > a {\n  color: #067272;\n  font-weight: 500;\n  cursor: auto;\n}\n\n\n// .modal-content {\n//   border-radius: 10px;\n//   padding: 1rem;\n// }\n\n@media (min-width: 800px)\n{\n  .modal-dialog {\n    max-width: fit-content;\n    //max-width: 600px;\n    //margin: 1.75rem auto;\n  }\n}\n\n.modal-body {\n  //padding: 2.4rem 2.4rem 2.4rem 2.4rem;\n  .h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n    margin-bottom: 1.25rem;\n    color: #022B2A;\n  }\n}\n\n\n\n// .myCustomModalClass {\n//     position: fixed;\n//     top: 20px;\n//     right: 20px;\n//     bottom: 20px;\n//     left: 20px;\n//     z-index: 1060;\n//     display: none;\n//     overflow: hidden;\n//     -webkit-overflow-scrolling: touch;\n//     outline: 0;\n// }\n\n// .modal.modal-fullscreen {\n//     /* Maximize the main wrappers on the screen */\n//     /* Make the parent wrapper of the modal box a full-width block */\n//     /* Remove borders and effects on the content */\n//     /**\n//        * /!\\ By using this feature, you force the header and footer to be placed\n//        * in an absolute position. You must handle by yourself the margin of the\n//        * content.\n//        */\n//   }\n//   .modal.modal-fullscreen .modal-dialog,\n//   .modal.modal-fullscreen .modal-content {\n//     bottom: 0;\n//     left: 0;\n//     position: absolute;\n//     right: 0;\n//     top: 0;\n//   }\n//   .modal.modal-fullscreen .modal-dialog {\n//     margin: 0;\n//     width: 100%;\n//     animation-duration:0.6s;\n//   }\n//   .modal.modal-fullscreen .modal-content {\n//     border: none;\n//     -moz-border-radius: 0;\n//     border-radius: 0;\n//     -webkit-box-shadow: inherit;\n//     -moz-box-shadow: inherit;\n//     -o-box-shadow: inherit;\n//     box-shadow: inherit;\n//     /* change bg color below */\n//    /* background:#1abc9c; */\n//   }\n//   .modal.modal-fullscreen.force-fullscreen {\n//     /* Remove the padding inside the body */\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-body {\n//     padding: 0;\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-header,\n//   .modal.modal-fullscreen.force-fullscreen .modal-footer {\n//     position: absolute;\n//     bottom: 0;\n//   }\n//   .modal.modal-fullscreen.force-fullscreen .modal-header {\n//     top: 0;\n//   }\n  \n  /* The styles above for the modal-body, footer, etc aren't being applied so I tried the ones below and they work */\n  .modal-body {\n    height: 100%;\n  }\n  \n  // .modal-footer {\n  //   width: 100%;\n  //   position: absolute;\n  //   bottom: 0;\n  //   background-color: #FFF;\n  // }\n  ","\n// Form styles\n.light-style__logo-container img {\n    width: 170px;\n    display: flex;\n    /* padding: 0px; */\n    align-items: center;\n    background: none;\n    border: 0px;\n    border-radius: 3px;\n    color: inherit;\n    cursor: pointer;\n    margin: 20px;\n}\n\n.light-style__floating-form-container {\n    width: 350px;\n    margin: 20px auto;\n    background-color: inherit;\n    border-radius: 15px;\n    padding: 4px;\n}\n\n.light-style__form-group {\n    margin-top: 20px;\n\n    label {\n        display: block;\n        margin-bottom: 10px;\n    }\n\n    input {\n        // width: 100%;\n        // padding: 10px;\n        // border-radius: 5px;\n        // border: 1px solid lightgray;\n        min-width: 0;\n        width: 100%;\n        height: 100%;\n        padding: 10px;\n        border: 1px solid #c4c7cf;\n        border-radius: 6px;\n        box-sizing: border-box;\n        color:  #191b23;\n        font-size: inherit;\n        text-overflow: ellipsis;\n        font-family: inherit;\n    }\n}\n\n.light-style__form-divider{\n    position: relative;\n    margin-top: 14px;\n    margin-bottom: 16px;\n    text-align: center;\n    border-top: 1px solid #d1d4db;\n    .divider-inner {\n        position: absolute;\n        top: -10px;\n        left: 0;\n        right: 0;\n        .divider-text {\n            background-color: #fff;\n            padding: 0 25px;\n            font-size: 14px;\n        }\n    }\n}\n\n// End Form styles\n\n// Link styles\n.light-style__quiet-link {\n    display: inline-block;\n    font-family: inherit;\n    color: #006dca;\n    line-height: normal;\n    position: relative;\n    cursor: pointer;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    box-shadow: none;\n    -webkit-tap-highlight-color: transparent;\n    outline: 0;\n    background: 0 0;\n    transition: color .15s ease-in-out;\n}\n\n// End Link styles\n\n// Button styles\n.light-style__button_form-submit {\n    background-color: rgba(205, 227, 227, 0.8);\n    width: 100%;\n    border: 0;\n    //border: 1px solid rgba(205, 227, 227, 0.8);\n    position: relative;\n    margin-bottom: 12px;\n    height: 40px;\n    border-radius: 6px;\n    font-size: 16px;\n}\n\n.light-style__button_third-party-auth {\n    background-color: #fff;\n    width: 100%;\n    border: 1px solid #c4c7cf;\n    position: relative;\n    margin-bottom: 12px;\n    height: 40px;\n    border-radius: 6px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 150%;\n\n    img {\n        margin-top: -4px;\n    }\n}\n\n.button_full-width {\n    width: 100%;\n}\n\n.light-style__cancel-button {\n    background-color: #fff;\n    border: 1px solid #022B2A;\n    color: #022B2A;\n    padding: 10px 16px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border-radius: 6px;\n}\n\n.light-style__confirm-button {\n    background-color: #022B2A;\n    border: 1px solid #022B2A;\n    color: #fff;\n    padding: 10px 16px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    border-radius: 6px;\n}\n\n\n// End button styles\n\nmain.light-style__page-container{\n\n    padding: 20px 40px;\n    max-width: 1080px;\n\n    \n    h5, .h5 {\n        font-size: 1.625rem;\n    }\n    \n    .page-header {\n        margin: 0;\n    }\n    \n    section {\n        margin-bottom: 30px;\n    }\n\n    .section-discription {\n        font-size: 1em;\n        color: lightslategray;\n        margin-bottom: 20px;\n    }\n}\n\n.light-style__modal-container{\n    > * {\n        padding: 1rem 2rem;\n    }\n\n    h5, .h5 {\n        font-size: 1.625rem;\n    }\n\n    h6 {\n        color: #022B2A;\n        font-weight: bold;\n    }\n\n    .modal-header {\n        display: flex;\n        flex-direction: column;\n        align-items: normal;\n        border-bottom: 1px solid #E5E5E5;\n    }\n\n    .page-header {\n        margin: 0;\n    }\n    \n    section {\n        margin-bottom: 30px;\n    }\n\n    .section-discription {\n        font-size: 1em;\n        color: lightslategray;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
